import React from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Breadcrumbs, H5, OL } from '../../../AbstractElements';
import { Bootstrap, Colorcode, ColoredBreadcrumb, Data, DefaultBootstrapBreadcrumb, Defaultcode, Home, Library, NavBreadcode, NavBreadcrumb, NavBreadtext, useclass } from '../../../Constant';

const BreadcrumbClassContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Breadcrumb' parent='Bonus-ui' title='Breadcrumb' />
      <Row>
        <Col md='6'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{DefaultBootstrapBreadcrumb}</H5>
              <span>
                {useclass} <code>{Defaultcode}</code>
              </span>
            </CardHeader>
            <CardBody>
              <OL className='breadcrumb p-t-0 p-l-0'>
                <li className='breadcrumb-item active'>{Home}</li>
              </OL>
              <OL className='breadcrumb p-l-0'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb p-l-0'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Library}</a>
                </li>
                <li className='breadcrumb-item active'>Data</li>
              </OL>
              <OL className='breadcrumb m-b-0 p-b-0 p-l-0'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>
                    <i className='fa fa-home'></i>
                  </a>
                </li>
                <li className='breadcrumb-item'>{Library}</li>
                <li className='breadcrumb-item active'>{Data}</li>
              </OL>
            </CardBody>
          </Card>
        </Col>
        <Col md='6'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{NavBreadcrumb}</H5>
              <span>
                {useclass} <code>{NavBreadcode}</code> {NavBreadtext}
              </span>
            </CardHeader>
            <CardBody>
              <nav className='breadcrumb'>
                <a className='breadcrumb-item' href='#javascript'>
                  {Home}
                </a>
                <a className='breadcrumb-item' href='#javascript'>
                  {Library}
                </a>
                <span className='breadcrumb-item active'>{Bootstrap}</span>
              </nav>
              <nav className='breadcrumb breadcrumb-icon'>
                <a className='breadcrumb-item' href='#javascript'>
                  {Home}
                </a>
                <a className='breadcrumb-item' href='#javascript'>
                  {Library}
                </a>
                <span className='breadcrumb-item active'>{Bootstrap}</span>
              </nav>
              <nav className='breadcrumb breadcrumb-no-divider mb-0'>
                <a className='breadcrumb-item' href='#javascript'>
                  {Home}
                </a>
                <a className='breadcrumb-item' href='#javascript'>
                  {Library}
                </a>
                <span className='breadcrumb-item active'>{Bootstrap}</span>
              </nav>
            </CardBody>
          </Card>
        </Col>
        <Col sm='12'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{ColoredBreadcrumb}</H5>
              <span>
                {useclass} <code>{Colorcode}</code>
              </span>
            </CardHeader>
            <CardBody>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-primary'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-secondary'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-success'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-info'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-warning'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-danger'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-30 bg-light'>
                <li className='breadcrumb-item'>
                  <a className='txt-dark' href='#javascript'>
                    {Home}
                  </a>
                </li>
                <li className='breadcrumb-item txt-dark active'>{Library}</li>
              </OL>
              <OL className='breadcrumb breadcrumb-colored m-b-0 bg-dark'>
                <li className='breadcrumb-item'>
                  <a href='#javascript'>{Home}</a>
                </li>
                <li className='breadcrumb-item active'>{Library}</li>
              </OL>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BreadcrumbClassContainer;
